import { ErrorHandler, inject, Injectable, Injector, Service } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Service()
export class GlobalErrorHandlerService extends ErrorHandler {
  private readonly _injector = inject(Injector);

  handleError(error: any): void {
    console.error(error);
    this._injector.get<ApplicationInsightsService>(ApplicationInsightsService).logException(error);
  }
}
